/**
 * Header.js
 * Main application header with navigation and user menu
 */

import React from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { authService } from '../../services/api';
import { CURRENT_VERSION } from '../../utils/versionChecker';
import NotificationBell from './NotificationBell';

const Header = () => {
  const currentUser = authService.getCurrentUser();
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const handleLogout = () => {
    authService.logout();
  };

  const handleProfileClick = () => {
    navigate('/profile');
  };

  const handleAuditClick = () => {
    navigate('/audit');
  };

  const handleSettingsClick = () => {
    navigate('/settings');
  };

  const handleAppSettingsClick = () => {
    navigate('/app-settings');
  };

  const handleBookingSettingsClick = () => {
    navigate('/booking-settings');
  };

  const handleMaintenanceClick = () => {
    navigate('/maintenance');
  };

  return (
    <Navbar bg="primary" variant="dark" expand="lg" className="header" fixed="top">
      <Container fluid>
        <Navbar.Brand href="/dashboard">
          <i className="fas fa-trophy me-2"></i>
          Fitmanager
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link href="/dashboard" className={isActive('/dashboard') ? 'active' : ''}>
              <i className="fas fa-tachometer-alt me-1"></i>
              Dashboard
            </Nav.Link>
            <Nav.Link href="/users" className={isActive('/users') ? 'active' : ''}>
              <i className="fas fa-users me-1"></i>
              Anagrafica
            </Nav.Link>
            <Nav.Link href="/courses" className={isActive('/courses') ? 'active' : ''}>
              <i className="fas fa-graduation-cap me-1"></i>
              Corsi
            </Nav.Link>
            <Nav.Link href="/course-offers" className={isActive('/course-offers') ? 'active' : ''}>
              <i className="fas fa-tag me-1"></i>
              Abbonamenti
            </Nav.Link>
            <Nav.Link href="/groups" className={isActive('/groups') ? 'active' : ''}>
              <i className="fas fa-users me-1"></i>
              Gruppi
            </Nav.Link>
            <Nav.Link href="/planner" className={isActive('/planner') ? 'active' : ''}>
              <i className="fas fa-calendar-alt me-1"></i>
              Planner
            </Nav.Link>
            {currentUser?.roles?.includes('admin') && (
              <Nav.Link href="/booking-settings" className={isActive('/booking-settings') ? 'active' : ''}>
                <i className="fas fa-clock me-1"></i>
                Prenotazioni
              </Nav.Link>
            )}
            <NavDropdown 
              title={
                <>
                  <i className="fas fa-box me-1"></i>
                  Noleggi
                </>
              }
              id="rentals-dropdown"
              className={isActive('/rentable-items') || isActive('/rentals') ? 'active' : ''}
            >
              <NavDropdown.Item href="/rentable-items">
                <i className="fas fa-boxes me-2"></i>
                Oggetti Noleggiabili
              </NavDropdown.Item>
              <NavDropdown.Item href="/rentals">
                <i className="fas fa-clipboard-list me-2"></i>
                Noleggi Attivi
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="/statistics" className={isActive('/statistics') ? 'active' : ''}>
              <i className="fas fa-chart-line me-1"></i>
              Statistiche
            </Nav.Link>
          </Nav>
          
          <Nav className="align-items-center">
            {currentUser?.roles?.includes('admin') && <NotificationBell />}
            <NavDropdown 
              title={
                <>
                  <i className="fas fa-user me-1"></i>
                  {currentUser?.firstName} {currentUser?.lastName}
                </>
              }
              id="user-dropdown"
              align="end"
            >
              <NavDropdown.ItemText>
                <strong>Versione {CURRENT_VERSION}</strong>
              </NavDropdown.ItemText>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleProfileClick}>
                <i className="fas fa-user-circle me-2"></i>
                Profilo
              </NavDropdown.Item>
              <NavDropdown.Item onClick={handleAuditClick}>
                <i className="fas fa-history me-2"></i>
                Audit
              </NavDropdown.Item>
              {currentUser?.roles?.includes('admin') && (
                <>
                  <NavDropdown.Item onClick={handleSettingsClick}>
                    <i className="fas fa-cog me-2"></i>
                    Impostazioni
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={handleAppSettingsClick}>
                    <i className="fas fa-sliders-h me-2"></i>
                    Parametri di Sistema
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={handleBookingSettingsClick}>
                    <i className="fas fa-calendar-check me-2"></i>
                    Gestione Prenotazioni
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={handleMaintenanceClick}>
                    <i className="fas fa-tools me-2"></i>
                    Manutenzione
                  </NavDropdown.Item>
                </>
              )}
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout}>
                <i className="fas fa-sign-out-alt me-2"></i>
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
